import { render, staticRenderFns } from "./PlayerCreditsSpecialistsReceived.vue?vue&type=template&id=7b0ddf66&scoped=true&"
import script from "./PlayerCreditsSpecialistsReceived.vue?vue&type=script&lang=js&"
export * from "./PlayerCreditsSpecialistsReceived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0ddf66",
  null
  
)

export default component.exports